import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change (smooth disabled because anchor handling)
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}
